(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-shipping-calculator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-shipping-calculator')) {
    customElements.define('product-shipping-calculator', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.form = this.querySelector('form');
        this.input = this.querySelector('[data-shipping-postcode]');
        this.message = this.querySelector('[data-shipping-message]');
        this.result = this.querySelector('[data-shipping-result]');
        this.submit = this.querySelector('[type="submit"]');
        this.apiUrl = `https://${this.dataset.storeDomain}/api/2026-07/graphql.json`;
        this.headers = {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': this.dataset.storefrontToken
        };

        const savedPostcode = localStorage.getItem('bgt_shipping_postcode');
        if (savedPostcode) this.input.value = savedPostcode;

        this.querySelector('.bgt-shipping__trigger').addEventListener('click', () => {
          this.dialog.showModal();
          this.input.focus();
        });
        this.querySelector('.bgt-shipping__close').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', event => {
          if (event.target === this.dialog) this.dialog.close();
        });
        this.form.addEventListener('submit', event => this.calculate(event));
      }

      getProductSelection() {
        const section = this.closest('.shopify-section') || document;
        const forms = [...section.querySelectorAll('form[action*="/cart/add"]')];
        const productForm = forms.find(form => form.querySelector('[name="id"]')) || forms[0];
        const variantInput = productForm?.querySelector('[name="id"]');
        const quantityInput = productForm?.querySelector('[name="quantity"]');
        return {
          variantId: variantInput?.value || this.dataset.initialVariant,
          quantity: Math.max(1, Number.parseInt(quantityInput?.value || '1', 10))
        };
      }

      getProvince(postcode) {
        const value = Number(postcode);
        if ((value >= 200 && value <= 299) || (value >= 2600 && value <= 2618) || (value >= 2900 && value <= 2920)) return 'ACT';
        if ((value >= 800 && value <= 999)) return 'NT';
        if ((value >= 1000 && value <= 2599) || (value >= 2619 && value <= 2899) || (value >= 2921 && value <= 2999)) return 'NSW';
        if ((value >= 3000 && value <= 3999) || (value >= 8000 && value <= 8999)) return 'VIC';
        if ((value >= 4000 && value <= 4999) || (value >= 9000 && value <= 9999)) return 'QLD';
        if (value >= 5000 && value <= 5999) return 'SA';
        if (value >= 6000 && value <= 6999) return 'WA';
        if (value >= 7000 && value <= 7999) return 'TAS';
        return null;
      }

      async graphql(query, variables, accept = 'application/json') {
        const response = await fetch(this.apiUrl, {
          method: 'POST',
          headers: { ...this.headers, Accept: accept },
          body: JSON.stringify({ query, variables })
        });
        if (!response.ok) throw new Error('The shipping service could not be reached.');
        return response;
      }

      parseDeferredResponse(text, contentType) {
  if (contentType.includes('application/json')) {
    return [JSON.parse(text)];
  }

  const boundaryMatch = contentType.match(/boundary="?([^";]+)"?/i);

  if (!boundaryMatch) {
    return [];
  }

  return text
    .split(`--${boundaryMatch[1]}`)
    .map(part => {
      const bodyStart = part.search(/\r?\n\r?\n/);
      return bodyStart === -1
        ? ''
        : part.slice(bodyStart).trim();
    })
    .filter(part => part.startsWith('{'))
    .map(part => {
      const end = part.lastIndexOf('}');
      return JSON.parse(part.slice(0, end + 1));
    });
}

      collectRates(payloads) {
        const rates = [];
        payloads.forEach(payload => {
          const directGroups = payload?.data?.cart?.deliveryGroups;
          const incrementalGroups = payload?.incremental || [];
          const groups = [
            ...(directGroups ? [directGroups] : []),
            ...incrementalGroups.map(item => item?.data?.deliveryGroups).filter(Boolean)
          ];
          groups.forEach(group => {
            group.edges?.forEach(edge => {
              edge.node?.deliveryOptions?.forEach(option => rates.push(option));
            });
          });
        });
        return [...new Map(rates.map(rate => [
          `${rate.title}-${rate.estimatedCost.amount}`,
          rate
        ])).values()].sort((a, b) => Number(a.estimatedCost.amount) - Number(b.estimatedCost.amount));
      }

      async calculate(event) {
        event.preventDefault();
        const postcode = this.input.value.trim();
        const provinceCode = this.getProvince(postcode);
        if (!/^\d{4}$/.test(postcode) || !provinceCode) {
          this.message.textContent = 'Please enter a valid four-digit Australian postcode.';
          return;
        }

        const { variantId, quantity } = this.getProductSelection();
        if (!variantId) {
          this.message.textContent = 'Please choose a product option first.';
          return;
        }

        this.submit.disabled = true;
        this.submit.textContent = 'Calculating…';
        this.message.textContent = '';

        const createMutation = `mutation ProductShippingCartCreate($input: CartInput!) {
          cartCreate(input: $input) {
            cart { id }
            userErrors { field message }
          }
        }`;

        const ratesQuery = `query ProductShippingRates($cartId: ID!) {
          cart(id: $cartId) {
            ...DeliveryGroups @defer
          }
        }
        fragment DeliveryGroups on Cart {
          deliveryGroups(first: 10, withCarrierRates: true) {
            edges {
              node {
                deliveryOptions {
                  title
                  estimatedCost { amount currencyCode }
                }
              }
            }
          }
        }`;

        try {
          const createResponse = await this.graphql(createMutation, {
            input: {
              lines: [{
                merchandiseId: `gid://shopify/ProductVariant/${variantId}`,
                quantity
              }],
              buyerIdentity: { countryCode: 'AU' },
              delivery: {
                addresses: [{
                  address: {
                    deliveryAddress: {
                      countryCode: 'AU',
                      provinceCode,
                      zip: postcode
                    }
                  },
                  selected: true,
                  oneTimeUse: true
                }]
              }
            }
          });
          const createPayload = await createResponse.json();
          const errors = createPayload.data?.cartCreate?.userErrors || [];
          const cartId = createPayload.data?.cartCreate?.cart?.id;
          if (!cartId || errors.length) throw new Error(errors[0]?.message || 'A quote could not be created.');

          const ratesResponse = await this.graphql(
            ratesQuery,
            { cartId },
            'multipart/mixed; deferSpec=20220824, application/json'
          );
          const payloads = this.parseDeferredResponse(
            await ratesResponse.text(),
            ratesResponse.headers.get('content-type') || ''
          );
          const rates = this.collectRates(payloads);
          if (!rates.length) throw new Error('No shipping options were found for this postcode.');

          localStorage.setItem('bgt_shipping_postcode', postcode);
          const formatter = new Intl.NumberFormat('en-AU', {
            style: 'currency',
            currency: rates[0].estimatedCost.currencyCode
          });
          this.result.innerHTML = rates.map(rate => `
            <div class="bgt-shipping__rate">
              <span>${this.escapeHtml(rate.title)}</span>
              <strong>${Number(rate.estimatedCost.amount) === 0 ? 'FREE' : formatter.format(rate.estimatedCost.amount)}</strong>
            </div>
          `).join('');
          this.result.hidden = false;
          this.classList.add('bgt-shipping--has-result');
          this.querySelector('[data-shipping-title]').textContent = `Delivery to ${postcode}`;
          this.querySelector('[data-shipping-summary]').textContent = `Shipping estimate for this item`;
          this.dialog.close();
        } catch (error) {
          this.message.textContent = error.message || 'We could not calculate shipping. Please try again.';
        } finally {
          this.submit.disabled = false;
          this.submit.textContent = 'Check shipping';
        }
      }

      escapeHtml(value) {
        const element = document.createElement('span');
        element.textContent = value;
        return element.innerHTML;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
